"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = void 0;
require("rc-calendar/assets/index.css");
require("rc-time-picker/assets/index.css");
require("./DateTimeStyle.css");
var react_1 = __importDefault(require("react"));
var lodash_1 = __importDefault(require("lodash"));
var moment_1 = __importDefault(require("moment"));
var Calendar_1 = __importDefault(require("rc-calendar/lib/Calendar"));
var Picker_1 = __importDefault(require("rc-calendar/lib/Picker"));
var Panel_1 = __importDefault(require("rc-time-picker/lib/Panel"));
var styled_components_1 = __importDefault(require("styled-components"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var Common_1 = require("../Common");
var DatePickerContainer = styled_components_1.default.div.attrs({
    className: 'tws-date-picker-container',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t& > span {\n\t\tdisplay: inline-flex;\n\t\twidth: fit-content;\n\t}\n\t.tws-date-picker-input {\n\t\twidth: 240px;\n\t\tmargin-right: 10px;\n\t\tpadding-right: 10px;\n\t}\n\t.tws-date-picker-button {\n\t\tbackground-color: ", " !important;\n\t\tborder-color: ", " !important;\n\t\t:hover {\n\t\t\tbackground-color: #04667c !important;\n\t\t\tborder-color: #04667c !important;\n\t\t}\n\t\t:not([disabled]):not(.disabled).active,\n\t\t:not([disabled]):not(.disabled):active {\n\t\t\tbackground-color: #04667c !important;\n\t\t\tborder-color: #04667c !important;\n\t\t}\n\t}\n"], ["\n\t& > span {\n\t\tdisplay: inline-flex;\n\t\twidth: fit-content;\n\t}\n\t.tws-date-picker-input {\n\t\twidth: 240px;\n\t\tmargin-right: 10px;\n\t\tpadding-right: 10px;\n\t}\n\t.tws-date-picker-button {\n\t\tbackground-color: ", " !important;\n\t\tborder-color: ", " !important;\n\t\t:hover {\n\t\t\tbackground-color: #04667c !important;\n\t\t\tborder-color: #04667c !important;\n\t\t}\n\t\t:not([disabled]):not(.disabled).active,\n\t\t:not([disabled]):not(.disabled):active {\n\t\t\tbackground-color: #04667c !important;\n\t\t\tborder-color: #04667c !important;\n\t\t}\n\t}\n"])), globalVars_module_scss_1.default.mainBlue, globalVars_module_scss_1.default.mainBlue);
var DateButton = (0, styled_components_1.default)(Common_1.Button).attrs({
    className: 'tws-date-picker-button',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t&.btn.btn-floating {\n\t\tdisplay: flex;\n\t\twidth: 60px;\n\t\tpadding: 0 12px;\n\t\tjustify-content: left;\n\t\t.date-icon {\n\t\t\tmargin: 0;\n\t\t}\n\t\t.date-caret {\n\t\t\tfont-size: 10px !important;\n\t\t\tmargin: 0 6px 0 8px;\n\t\t\twidth: auto !important;\n\t\t}\n\t}\n"], ["\n\t&.btn.btn-floating {\n\t\tdisplay: flex;\n\t\twidth: 60px;\n\t\tpadding: 0 12px;\n\t\tjustify-content: left;\n\t\t.date-icon {\n\t\t\tmargin: 0;\n\t\t}\n\t\t.date-caret {\n\t\t\tfont-size: 10px !important;\n\t\t\tmargin: 0 6px 0 8px;\n\t\t\twidth: auto !important;\n\t\t}\n\t}\n"])));
DateButton.displayName = 'DateButton';
var ClearButton = styled_components_1.default.a(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tcolor: ", " !important;\n\tdisplay: block;\n\tfont-size: 12px;\n\tmargin-top: 5px;\n\ttext-decoration: underline;\n\twidth: fit-content;\n\t&:hover {\n\t\ttext-decoration: none;\n\t}\n\t&:not([href]):not([tabindex]) {\n\t\ttext-decoration: underline;\n\t}\n"], ["\n\tcolor: ", " !important;\n\tdisplay: block;\n\tfont-size: 12px;\n\tmargin-top: 5px;\n\ttext-decoration: underline;\n\twidth: fit-content;\n\t&:hover {\n\t\ttext-decoration: none;\n\t}\n\t&:not([href]):not([tabindex]) {\n\t\ttext-decoration: underline;\n\t}\n"])), globalVars_module_scss_1.default.mainBlue);
ClearButton.displayName = 'ClearButton';
var CloseButton = styled_components_1.default.button.attrs({
    className: 'date-picker-close-button',
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tdisplay: flex;\n\tposition: absolute;\n\ttop: -4px;\n\tright: -4px;\n\tbackground-color: transparent;\n\tborder-radius: 50%;\n\twidth: 30px;\n\theight: 30px;\n\ttext-align: center;\n\tcursor: pointer;\n\tcolor: ", ";\n\tborder: ", " ", " transparent;\n\tfont-weight: 600;\n\tjustify-content: center;\n\talign-items: center;\n\tfont-size: 12px;\n\tbox-shadow: ", ";\n\tfloat: right;\n\t&:hover {\n\t\tborder: ", " ", " ", ";\n\t\tbox-shadow: ", ";\n\t\tcolor: ", ";\n\t\tbackground-color: ", ";\n\t}\n"], ["\n\tdisplay: flex;\n\tposition: absolute;\n\ttop: -4px;\n\tright: -4px;\n\tbackground-color: transparent;\n\tborder-radius: 50%;\n\twidth: 30px;\n\theight: 30px;\n\ttext-align: center;\n\tcursor: pointer;\n\tcolor: ", ";\n\tborder: ", " ", " transparent;\n\tfont-weight: 600;\n\tjustify-content: center;\n\talign-items: center;\n\tfont-size: 12px;\n\tbox-shadow: ", ";\n\tfloat: right;\n\t&:hover {\n\t\tborder: ", " ", " ", ";\n\t\tbox-shadow: ", ";\n\t\tcolor: ", ";\n\t\tbackground-color: ", ";\n\t}\n"])), globalVars_module_scss_1.default.mainGray, globalVars_module_scss_1.default.borderThick, globalVars_module_scss_1.default.borderSolid, globalVars_module_scss_1.default.shadow0, globalVars_module_scss_1.default.borderThick, globalVars_module_scss_1.default.borderSolid, globalVars_module_scss_1.default.white, globalVars_module_scss_1.default.shadow3, globalVars_module_scss_1.default.white, globalVars_module_scss_1.default.mainBlue);
CloseButton.displayName = 'CloseButton';
var defaultFormat = 'MMM D, YYYY [at] h:mma (Z)';
var now = (0, moment_1.default)();
var DatePicker = /** @class */ (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (value) {
            var _a = _this.props, defaultGap = _a.defaultGap, enabledStartDate = _a.enabledStartDate, enabledEndDate = _a.enabledEndDate, showMinute = _a.showMinute, showSecond = _a.showSecond;
            // No change to selectedDate state if selected date is out of
            // enabledStartDate/enabledEndDate range
            if ((enabledStartDate && (0, moment_1.default)(value).isBefore(enabledStartDate, 'day')) ||
                (enabledEndDate && (0, moment_1.default)(value).isAfter(enabledEndDate, 'day'))) {
                return;
            }
            var date = (0, moment_1.default)(value).toDate();
            if (enabledStartDate || enabledEndDate) {
                // Set selectedDate to enabledStartDate
                // if value is on the same day of enabledStartDate and value is earlier than enabledStartDate
                if (enabledStartDate) {
                    if ((0, moment_1.default)(date).isSame(enabledStartDate, 'day') && (0, moment_1.default)(date).isSameOrBefore(enabledStartDate)) {
                        date = (0, moment_1.default)(enabledStartDate).add(defaultGap, 'hour').toDate();
                    }
                }
                // Set selectedDate to enabledEndDate
                // if value is on the same day of enabledEndDate and value is later than enabledStartDate
                if (enabledEndDate) {
                    if ((0, moment_1.default)(date).isSame(enabledEndDate, 'day') && (0, moment_1.default)(date).isAfter(enabledEndDate)) {
                        date = enabledEndDate.toDate();
                    }
                }
            }
            if (!showMinute) {
                date.setMinutes(0);
            }
            if (!showSecond) {
                date.setSeconds(0);
            }
            date.setMilliseconds(0);
            _this.setState({ selectedDate: (0, moment_1.default)(date) });
        };
        _this.onOpenChange = function (open) {
            if (!_this.props.enableInput) {
                if (open) {
                    // Delay to ensure the calendar input field has been rendered
                    setTimeout(function () {
                        var targetCalendarInput = document.getElementsByClassName('rc-calendar-input');
                        if (targetCalendarInput && targetCalendarInput.length > 0) {
                            lodash_1.default.each(targetCalendarInput, function (input) {
                                input.setAttribute('readonly', 'readonly');
                            });
                        }
                    }, 100);
                }
            }
        };
        _this.handleOnClear = function () {
            var onClear = _this.props.onClear;
            _this.setState({ originalDate: undefined, open: false }, function () {
                if (onClear) {
                    onClear();
                }
            });
        };
        _this.handleOnClose = function () {
            _this.setState({ open: false });
        };
        var date = _this.props.value;
        _this.state = {
            selectedDate: date ? (0, moment_1.default)(date) : undefined,
            originalDate: date ? (0, moment_1.default)(date) : '',
            open: false,
        };
        _this.onChange = _this.onChange.bind(_this);
        _this.onOpenChange = _this.onOpenChange.bind(_this);
        _this.handleOnApply = _this.handleOnApply.bind(_this);
        _this.handleOnOpen = _this.handleOnOpen.bind(_this);
        _this.handleOnClear = _this.handleOnClear.bind(_this);
        _this.handleOnClose = _this.handleOnClose.bind(_this);
        _this.disabledDate = _this.disabledDate.bind(_this);
        _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
        return _this;
    }
    DatePicker.prototype.componentDidMount = function () {
        document.addEventListener('mousedown', this.handleDocumentClick);
    };
    DatePicker.prototype.componentWillUnmount = function () {
        document.removeEventListener('mousedown', this.handleDocumentClick);
    };
    DatePicker.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        this.setState({ originalDate: nextProps.value ? (0, moment_1.default)(nextProps.value) : '' });
    };
    DatePicker.prototype.getTimePicker = function () {
        var _a = this.props, defaultGap = _a.defaultGap, enabledStartDate = _a.enabledStartDate, enabledEndDate = _a.enabledEndDate;
        var selectedDate = this.state.selectedDate;
        return (react_1.default.createElement(Panel_1.default, { defaultValue: (0, moment_1.default)('00:00:00', 'HH:mm:ss'), showMinute: this.props.showMinute, showSecond: this.props.showSecond, use12Hours: this.props.use12Hours, format: 'h:mm a', disabledHours: function () {
                var selectedDateMoment = (0, moment_1.default)(selectedDate);
                // Disable hours if selected date is same as enabledStartDate
                if (enabledStartDate && (0, moment_1.default)(enabledStartDate).isSame(selectedDateMoment, 'day')) {
                    var enabledStartDateHour = (0, moment_1.default)(enabledStartDate).hours();
                    if (enabledStartDateHour !== 0) {
                        return lodash_1.default.range(0, enabledStartDateHour + defaultGap);
                    }
                }
                // Disable hours if selected date is same as enabledEndDate
                if (enabledEndDate && (0, moment_1.default)(enabledEndDate).isSame(selectedDateMoment, 'day')) {
                    var enabledEndDateHour = (0, moment_1.default)(enabledEndDate).hours();
                    if (enabledEndDateHour !== 0) {
                        return lodash_1.default.range(enabledEndDateHour + 1, 24);
                    }
                }
                // Disable all hours
                if ((enabledStartDate && selectedDateMoment.isBefore(enabledStartDate, 'day')) ||
                    (enabledEndDate && selectedDateMoment.isAfter(enabledEndDate, 'day'))) {
                    return lodash_1.default.range(0, 24);
                }
                return undefined;
            } }));
    };
    DatePicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, _b = _a.applyButtonText, applyButtonText = _b === void 0 ? 'Apply' : _b, className = _a.className, _c = _a.clearText, clearText = _c === void 0 ? 'Clear' : _c, _d = _a.dateFormat, dateFormat = _d === void 0 ? defaultFormat : _d;
        var _e = this.state, originalDate = _e.originalDate, selectedDate = _e.selectedDate;
        var calendarRender = (react_1.default.createElement(Calendar_1.default, { className: 'tws-calendar tws-date-picker', defaultValue: now, format: dateFormat, dateInputPlaceholder: this.props.dateInputPlaceholder, disabledDate: this.disabledDate, showToday: false, showOk: false, timePicker: this.props.showTime ? this.getTimePicker() : null, renderFooter: function () {
                return _this.props.showTime ? (react_1.default.createElement(Common_1.Button, { id: 'applyButton', color: 'primary', size: 'sm', onClick: _this.handleOnApply }, applyButtonText)) : null;
            }, renderSidebar: function () { return (react_1.default.createElement("div", { className: 'tws-calendar-header', key: _this.props.value },
                react_1.default.createElement("div", { className: 'tws-calendar-header-label' }, _this.props.headerLabel ? _this.props.headerLabel : ''),
                react_1.default.createElement(CloseButton, { onClick: _this.handleOnClose },
                    react_1.default.createElement(Common_1.Icon, { name: 'close' })))); }, onClear: this.handleOnClear }));
        return (react_1.default.createElement(DatePickerContainer, { className: className },
            react_1.default.createElement(Picker_1.default, { open: this.state.open, placement: this.props.placement, value: selectedDate, onChange: this.onChange, animation: 'slide-up', calendar: calendarRender }, function (_a) {
                var value = _a.value;
                return (react_1.default.createElement("span", { tabIndex: 0 },
                    react_1.default.createElement(Common_1.TwsInput, __assign({}, _this.props, { value: originalDate ? (0, moment_1.default)(originalDate).format(dateFormat) : '', className: 'tws-date-picker-input', placeholder: _this.props.textInputPlaceholder, onFocus: function () { return _this.handleOnOpen(new Date()); }, onChange: function () {
                            /* */
                        } })),
                    react_1.default.createElement(DateButton, { onClick: function () { return _this.handleOnOpen(new Date()); }, floating: true, color: 'primary' },
                        react_1.default.createElement(Common_1.Icon, { name: 'calendar', className: 'date-icon' }),
                        react_1.default.createElement(Common_1.Icon, { name: 'angle-down', className: 'date-caret' }))));
            }),
            this.props.showClear && react_1.default.createElement(ClearButton, { onClick: this.handleOnClear }, clearText),
            this.getExtraMessage()));
    };
    DatePicker.prototype.disabledDate = function (current) {
        var _a = this.props, enabledStartDate = _a.enabledStartDate, enabledEndDate = _a.enabledEndDate;
        var currentClone = lodash_1.default.cloneDeep(current);
        var startOfCurrentDay = currentClone.startOf('day');
        if (enabledStartDate && enabledEndDate) {
            return startOfCurrentDay.isBefore(enabledStartDate, 'day') || startOfCurrentDay.isAfter(enabledEndDate, 'day');
        }
        else if (enabledStartDate) {
            return startOfCurrentDay.isBefore(enabledStartDate, 'day');
        }
        else if (enabledEndDate) {
            return startOfCurrentDay.isAfter(enabledEndDate, 'day');
        }
        return false;
    };
    DatePicker.prototype.handleOnOpen = function (date) {
        var _this = this;
        var _a = this.props, defaultHour = _a.defaultHour, showMinute = _a.showMinute, showSecond = _a.showSecond;
        var originalDate = this.state.originalDate;
        if (defaultHour !== undefined) {
            date.setHours(defaultHour);
        }
        if (this.props.enabledStartDate || this.props.enabledEndDate) {
            if (this.props.enabledStartDate) {
                if (this.props.enabledStartDate.isSameOrAfter((0, moment_1.default)(date))) {
                    date = this.props.enabledStartDate.toDate();
                }
            }
            if (this.props.enabledEndDate && this.props.enabledEndDate.isSameOrBefore((0, moment_1.default)(date))) {
                date = this.props.enabledEndDate.toDate();
            }
        }
        if (!showMinute) {
            date.setMinutes(0);
        }
        if (!showSecond) {
            date.setSeconds(0);
        }
        date.setMilliseconds(0);
        var originalSelectedDate = originalDate || undefined;
        this.setState({ selectedDate: originalSelectedDate, open: true }, function () {
            _this.onOpenChange(true);
        });
    };
    DatePicker.prototype.getExtraMessage = function () {
        if (this.props.error) {
            return Common_1.MessageHelper.getFormattedErrorMessages(this.props.message);
        }
        if (this.props.success) {
            return Common_1.MessageHelper.getFormattedSuccessMessages(this.props.message);
        }
        return null;
    };
    DatePicker.prototype.handleOnApply = function () {
        var onChange = this.props.onChange;
        var selectedDate = this.state.selectedDate;
        var originalDate = selectedDate;
        this.setState({ originalDate: originalDate, open: false }, function () {
            if (onChange) {
                onChange(selectedDate);
            }
        });
    };
    DatePicker.prototype.handleDocumentClick = function (e) {
        var container = document.getElementsByClassName('rc-calendar-picker');
        if (container && container.length > 0) {
            if (!container[0].contains(e.target)) {
                this.setState({
                    open: false,
                });
            }
        }
    };
    // Default props
    DatePicker.defaultProps = {
        defaultGap: 0,
        use12Hours: true,
        showClear: true,
        showTime: true,
        showMinute: true,
        showSecond: false,
        dateInputPlaceholder: 'Select a date',
        textInputPlaceholder: 'No date selected',
        placement: 'bottomLeft',
        enableInput: true,
    };
    return DatePicker;
}(react_1.default.Component));
exports.DatePicker = DatePicker;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
